import { put, call, takeLatest } from 'redux-saga/effects'
import services from '../../services'
import {
  ES_BLUE_COLLAR,
  ES_BLUE_COLLAR_ERROR,
  ES_BLUE_COLLAR_SUCCESS,
  GET_SUSCRIPCION_AUTOPOSTULACION,
  GET_SUSCRIPCION_AUTOPOSTULACION_ERROR,
  GET_SUSCRIPCION_AUTOPOSTULACION_SUCCESS,
  PUT_SUSCRIPCION_AUTOPOSTULACION,
  PUT_SUSCRIPCION_AUTOPOSTULACION_ERROR,
  PUT_SUSCRIPCION_AUTOPOSTULACION_SUCCESS,
} from '../types/autopostulacion'

function* esBlueCollar() {
  try {
    const response = yield call(services.autopostulacion.esBlueCollar)
    yield put({ type: ES_BLUE_COLLAR_SUCCESS, payload: { blueCollar: response } })
  } catch (error) {
    yield put({ type: ES_BLUE_COLLAR_ERROR, error })
  }
}

function* suscriptoAutopostulacion() {
  try {
    const response = yield call(services.autopostulacion.suscriptoAutopostulacion)
    yield put({ type: GET_SUSCRIPCION_AUTOPOSTULACION_SUCCESS, payload: { suscripto: response } })
  } catch (error) {
    yield put({ type: GET_SUSCRIPCION_AUTOPOSTULACION_ERROR, error })
  }
}

function* suscribirAutopostulacion({ payload }) {
  try {
    yield call(services.autopostulacion.suscribirAutopostulacion, payload.suscribir)
    yield put({ type: PUT_SUSCRIPCION_AUTOPOSTULACION_SUCCESS })
  } catch (error) {
    yield put({ type: PUT_SUSCRIPCION_AUTOPOSTULACION_ERROR, error })
  }
}

/**
 * Watchers
 */
export default function* autopostulacion() {
  yield takeLatest<any>(ES_BLUE_COLLAR, esBlueCollar)
  yield takeLatest<any>(GET_SUSCRIPCION_AUTOPOSTULACION, suscriptoAutopostulacion)
  yield takeLatest<any>(PUT_SUSCRIPCION_AUTOPOSTULACION, suscribirAutopostulacion)
}
